import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sending"
export default class extends Controller {
  static targets = ["loadingScreen"]

  declare readonly loadingScreenTarget: HTMLElement

  initialize() {
    // Turbo を読み込んだらローディングを消す
    document.addEventListener('turbo:load', () => {
      this.hideLoadingScreen()
    })
  }

  connect() {
    // ブラウザバックを含むページ遷移の都度コールいてローディングをリセット
    this.hideLoadingScreen()
  }

  submit() {
    this.loadingScreenTarget?.style.setProperty("display", "block")
  }

  hideLoadingScreen() {
    this.loadingScreenTarget?.style.setProperty("display", "none")
  }

  disconnect() {
    this.hideLoadingScreen()
  }
}
